// Product-history helpers for loon transaction labels, formatting, and sorting
const PRODUCT_LOON_TRANSACTION_LABELS = {
    purchase: 'Purchase',
    promo: 'Promo',
    support: 'Support',
    gift: 'Gift',
    signup: 'Signup Bonus',
    gameStart: 'Game Start',
    refundReversal: 'Refund Reversal',
    disputeClawback: 'Dispute Clawback',
    disputeReinstatement: 'Dispute Reinstatement',
    correction: 'Correction',
    achievement: 'Achievement',
};
const PRODUCT_LOON_TRANSACTION_DATE_FORMATTER = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
});
export const getProductLoonTransactionLabel = (type) => PRODUCT_LOON_TRANSACTION_LABELS[type] || type;
export const formatProductLoonTransactionDate = (value) => {
    const date = typeof value === 'string' ? new Date(value) : value;
    if (Number.isNaN(date.getTime())) {
        return '-';
    }
    return PRODUCT_LOON_TRANSACTION_DATE_FORMATTER.format(date);
};
export const formatProductLoonTransactionDelta = (value) => {
    const absValue = Math.abs(value);
    return `${value >= 0 ? '+' : '-'}${absValue.toLocaleString('en-US')}`;
};
export const sortProductHistoryTransactionsNewestFirst = (transactions) => [...transactions].sort((left, right) => new Date(right.createdAt).getTime() - new Date(left.createdAt).getTime());
//# sourceMappingURL=getProductHistory.js.map